/**
 * Reader-only projection of the approved first Tome I Story.
 * Splits one long frozen Story at its existing "От автора" editorial
 * transition. Never edits, persists, or re-approves the frozen block.
 */
export function splitTomeIntroLongform(block) {
  const content = block?.content || {};
  const paragraphs = Array.isArray(content.extra?.paragraphs)
    ? content.extra.paragraphs : [];
  const headingIndex = paragraphs.findIndex(
    (p) => typeof p === "string" && p.trim().toLocaleLowerCase("ru") === "от автора"
  );
  const boundary = paragraphs.length > 16
    ? (headingIndex > 0 ? headingIndex : Math.min(10, paragraphs.length))
    : paragraphs.length;
  const continuation = paragraphs.slice(boundary);
  if (!continuation.length) {
    return { opening: block, continuation: [], finalQuote: null };
  }
  return {
    opening: {
      ...block,
      content: {
        ...content,
        quote: null,
        extra: { ...content.extra, paragraphs: paragraphs.slice(0, boundary) },
      },
    },
    continuation,
    finalQuote: content.quote || null,
  };
}
